import actions from "@state/actions";
import { Dispatch } from "redux";
import { IBrand } from "./types";
import { IBrandDefinition } from "@state/dsconfig/types";

export const fetchBrandById = (dispatch: Dispatch, id: string) => {      
  return new Promise<IBrand>((resolve, reject) => {
    dispatch(actions.brands.getBrand(`/${id}`, (result, error) => {
      if (error) reject(error)
      else resolve(result)
    }))
  });
}

export const brandToDSConfigBrand = (brand: IBrand): IBrandDefinition => {
  return {
    id: brand.id,
    name: brand.name,
    colorPalette: brand.colors.map(c => c.color) ?? [],
    fonts: brand.fonts ?? [],
    modelTrimSpecificImages: [],
    brandStockImages: [],
    oem: brand.oem
  }
}
